import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Responsive from 'react-responsive'

const Desktop = props => <Responsive {...props} minWidth={1025} />
const Tablet = props => <Responsive {...props} minWidth={736} maxWidth={1024}/>
const Mobile = props => <Responsive {...props} maxWidth={735} />

class Card extends Component {
  render() {
    return (
    <div>
      <Desktop>
        <div className={this.props.classes.Container} style={this.props.style}>
          {this.props.children}
        </div>
      </Desktop>
      <Tablet>
        <div className={this.props.classes.ContainerTablet} style={this.props.style}>
          {this.props.children}
        </div>        
      </Tablet>
      <Mobile>
        <div className={this.props.classes.ContainerMobile} style={this.props.style}>
          {this.props.children}
        </div>
      </Mobile>
    </div>
    )
  }
}

const styles = {
    Container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        minWidth: '25rem',
        minHeight: '5rem',        
        borderRadius: '5px',
        paddingTop: '1rem',
        // boxShadow: '2px 2px 10px 2px rgba(0, 0, 0, 0.2)',
        // backgroundColor: palette.darkFontBG,
        zIndex: '1'
    },
    ContainerTablet: {
      extend: 'Container',
      minWidth: '60vw',      
    },
    ContainerMobile: {
      extend: 'Container',
      minWidth: '90vw',
      maxWidth: '90vw',
      // maxHeight: '85vh'
    }
}

export default injectSheet(styles)(Card)


// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/Card.jsx